module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1g_R.7652a9bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-1g_R.svg
// module id = 515
// module chunks = 0